import { useState, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { UnifiedSidebar } from './UnifiedSidebar';
import { Header } from './Header';
import { THEME } from '../../styles/theme';

/**
 * Main Layout Component
 * Validates: Requirements 20.1 - Responsive design for desktop and tablet
 * Validates: Requirements 20.3 - Unified navigation with context-specific content
 */
export function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const handleOpenSidebar = useCallback(() => {
    setSidebarOpen(true);
  }, []);

  const handleCloseSidebar = useCallback(() => {
    setSidebarOpen(false);
  }, []);

  return (
    <div
      className="min-h-screen flex overflow-hidden relative"
      style={{ background: THEME.bg }}
    >
      {/* Background glow effect */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background: 'radial-gradient(ellipse at 50% -20%, rgba(255, 51, 102, 0.08) 0%, transparent 60%)',
        }}
      />

      {/* Unified Sidebar with glass morphism */}
      <UnifiedSidebar isOpen={sidebarOpen} onClose={handleCloseSidebar} />

      {/* Main content area */}
      <div className="flex-1 flex flex-col min-w-0 relative">
        {/* Mobile header */}
        <Header onMenuClick={handleOpenSidebar} />

        {/* Page content */}
        <main className="flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
